import { Injectable, Inject } from '@angular/core';
import { FrattaleService } from './frattale.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DbangService extends FrattaleService {

  constructor(@Inject(HttpClient) protected http: HttpClient) { 
    super(http) 
  }

  index(){
    let data = {
      action: "dbang/index"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  updateBang2(market: string){
    let data = {
      action: "dbang/update",
      market: market
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  
  marketsDailyBang() {
    let p = { action: 'dbang/update_daily_bang2', cmd: 'markets' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  updateDailyBang2(mkt: string) {
    let p = { action: 'dbang/update_daily_bang2', cmd: 'update_bang2', market: mkt }
    return this.http.post(this.url, p, { headers: this.head })
  }

  updateDailyBang2Rawal(mkt: string) {
    let p = { action: 'dbang/update_rawal', cmd: 'update_rawal', market: mkt }
    return this.http.post(this.url, p, { headers: this.head })
  }

  updateDailyBang2RawalBT(mkt: string) {
    let p = { action: 'dbang/update_dbang_rawal_bt', cmd: 'update_rawalBT', market: mkt }
    return this.http.post(this.url, p, { headers: this.head })
  }

}
